module.exports = __webpack_public_path__ + "static/features-screenshot-5b8ec1d28ce837e73734925ea58aad90.svg";